import RMButton from 'components/customComponents/Controls/RMButton';
import React from 'react';

function WizardCreateExpButton({ onClick, text, style = null, disabled = false }: any) {
  return (
    <div
      id='wizardcreateexpbutton-wrapper'
      style={{
        borderRadius: '8px',
        width: '130px',
        height: '3rem',
        maxHeight: '3rem',
        fontSyle: 'Roboto',
        fontSize: '1rem',
        lineHeight: '1.1875',
        fontWeight: '500',
        ...style,
      }}
    >
      <RMButton
        id='wizardcreateexpbutton-button'
        onClick={onClick}
        disabled={disabled}
        label={text}
        fullWidth={true}
      ></RMButton>
    </div>
  );
}

export default WizardCreateExpButton;
